"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
exports.__esModule = true;
exports.EUrlOpeningMode = exports.AD_PROVIDERS = exports.SUBSCRIPTION_STATUSES = exports.RADAR_CONSTS = exports.DEFAULT_BANNER_SIZE = exports.BANNER_SIZES = exports.REWARDED_VIDEO_LOOTPACK_PLATFORMS = exports.BUNDLE_CAMPAIGN_TYPES = exports.BUNDLES = exports.CONTACT_VIEW_CONSTRAINS = exports.EARN_DIAMONDS_HINT_KEYS_LIST = exports.EARN_COINS_HINT_KEYS_LIST = exports.TRADING_CAMPAIGN_TYPES = exports.TUTORIALS_PLACEMENT = exports.SLOT_PLACEMENT_DATA = exports.SLOTS_PLACEMENT = exports.INTERNAL_PATH = exports.MONEY_CURRENCIES = exports.CURRENCIES = exports.SORTING_OPTIONS = exports.PREMIUM_CARD_EXCHANGE_REWARDS = exports.LOOTCOIN_BONUSES = exports.STYLES = exports.CONTENT_TYPES = exports.SLOT_TYPE_DATA = exports.SLOT_SUBTYPES = exports.SLOT_TYPES = void 0;
exports.SLOT_TYPES = {
    BANNER_SLOT: 'banner',
    BANNER_SLOT_2: 'banner_2',
    HEADLINE_SLOT: 'headline',
    LOOT_SLOT: 'loot',
    YOUTUBE_SLOT: 'youtube',
    ADMOB_SLOT: 'admob'
};
exports.SLOT_SUBTYPES = {
    COLLECTION: 'collection'
};
exports.SLOT_TYPE_DATA = (_a = {},
    _a[exports.SLOT_TYPES.BANNER_SLOT] = {
        displayName: 'banner_horizontal'
    },
    _a[exports.SLOT_TYPES.BANNER_SLOT_2] = {
        displayName: 'banner_flexible'
    },
    _a[exports.SLOT_TYPES.LOOT_SLOT] = {
        displayName: exports.SLOT_TYPES.LOOT_SLOT
    },
    _a[exports.SLOT_TYPES.YOUTUBE_SLOT] = {
        displayName: exports.SLOT_TYPES.YOUTUBE_SLOT
    },
    _a[exports.SLOT_TYPES.ADMOB_SLOT] = {
        displayName: 'ad_banner'
    },
    _a[exports.SLOT_TYPES.HEADLINE_SLOT] = {
        displayName: exports.SLOT_TYPES.HEADLINE_SLOT,
        subTypes: [exports.SLOT_SUBTYPES.COLLECTION]
    },
    _a);
exports.CONTENT_TYPES = {
    MARKDOWN: 'text/markdown',
    YOUTUBE: 'youtube',
    TEMPLATE: 'template',
    CARD_SECTION: 'cards',
    PRESENTER_SECTION: 'presenters',
    AD: 'ad',
    SLOT: 'slot'
};
exports.STYLES = {
    NORMAL: 'normal',
    SMALL: 'small'
};
exports.LOOTCOIN_BONUSES = {
    NEWSLETTER: 500
};
exports.PREMIUM_CARD_EXCHANGE_REWARDS = {
    MIN: 1,
    MAX: 40
};
exports.SORTING_OPTIONS = {
    DATE_ASCENDING: 'oldest',
    DATE_DESCENDING: 'newest',
    RATING_ASCENDING: 'ratingAscending',
    RATING_DESCENDING: 'ratingDescending'
};
exports.CURRENCIES = {
    DIAMOND_CURRENCY: 'LOOTGEM',
    FREE_CURRENCY: 'FREE',
    LOOTCOIN_CURRENCY: 'LOOTCOIN',
    AD_CURRENCY: 'REWARDED_VIDEO'
};
exports.MONEY_CURRENCIES = {
    EUR: 'EUR',
    CHF: 'CHF',
    GBP: 'GBP',
    USD: 'USD',
    BRL: 'BRL'
};
exports.INTERNAL_PATH = 'lootboy:/';
exports.SLOTS_PLACEMENT = {
    HOME: 'home',
    DIAMONDS: 'diamonds',
    JOBS: 'jobs',
    PLAY: 'play'
};
var regularSlotTypes = [
    exports.SLOT_TYPES.BANNER_SLOT,
    exports.SLOT_TYPES.BANNER_SLOT_2,
    exports.SLOT_TYPES.LOOT_SLOT,
    exports.SLOT_TYPES.YOUTUBE_SLOT,
    exports.SLOT_TYPES.ADMOB_SLOT,
    exports.SLOT_TYPES.HEADLINE_SLOT,
];
exports.SLOT_PLACEMENT_DATA = (_b = {},
    _b[exports.SLOTS_PLACEMENT.HOME] = {
        allowedSlotTypes: regularSlotTypes
    },
    _b[exports.SLOTS_PLACEMENT.DIAMONDS] = {
        allowedSlotTypes: regularSlotTypes
    },
    _b[exports.SLOTS_PLACEMENT.JOBS] = {
        allowedSlotTypes: [
            exports.SLOT_TYPES.BANNER_SLOT,
            exports.SLOT_TYPES.BANNER_SLOT_2,
            exports.SLOT_TYPES.ADMOB_SLOT,
        ]
    },
    _b[exports.SLOTS_PLACEMENT.PLAY] = {
        allowedSlotTypes: regularSlotTypes
    },
    _b);
exports.TUTORIALS_PLACEMENT = __assign(__assign({}, exports.SLOTS_PLACEMENT), { COMICS: 'comics', INVENTORY: 'inventory', RADAR: 'radar' });
exports.TRADING_CAMPAIGN_TYPES = {
    SHRED_TRADING: 'SHRED_TRADING',
    BALANCE_TRADING: 'BALANCE_TRADING'
};
exports.EARN_COINS_HINT_KEYS_LIST = {
    BOOST: 'Boost',
    COMICS: 'Comics',
    INVITES: 'Invites',
    SHREDDING: 'Shredding'
};
exports.EARN_DIAMONDS_HINT_KEYS_LIST = {
    BONUS_MISSIONS: 'Bonus Missions',
    BOOST: 'Boost',
    EXPLORATION_QUESTS: 'Exploration Quests',
    WEB_DIAMOND_DUNGEON: 'Diamond Dungeon (Web)',
    WEB_SURVEY_QUESTS: 'Survey Quests (Web)',
    WEB_DIAMOND_DREAM: 'Diamond Dream (Web)'
};
exports.CONTACT_VIEW_CONSTRAINS = {
    MAX_ATTACHMENT_SIZE: 1024 * 1024 * 5,
    MAX_ATTACHMENT_COUNT: 5,
    MAX_EMAIL_LENGTH: 256,
    MAX_TEXT_LENGTH: 1024
};
exports.BUNDLES = ['x1', 'x2', 'x5', 'x10', 'x25'];
exports.BUNDLE_CAMPAIGN_TYPES = {
    EVERY_LOOTPACK: 'every',
    DIAMOND_LOOTPACKS: 'diamond',
    MONEY_LOOTPACKS: 'money',
    PROFITABLE_LOOTPACKS: 'profitable',
    SELECTION: 'selection'
};
exports.REWARDED_VIDEO_LOOTPACK_PLATFORMS = {
    google: true,
    ios: true,
    huawei: false,
    amazon: false,
    // if rewarded video lootpack is requested with `platform=web` query
    // backend will return it only if it has fallbackCurrency set
    web: true
};
exports.BANNER_SIZES = {
    BANNER: '320x50',
    LARGE_BANNER: '320x100',
    MEDIUM_RECTANGLE: '300x250',
    FULL_SIZE_BANNER: '468x60'
};
exports.DEFAULT_BANNER_SIZE = exports.BANNER_SIZES.LARGE_BANNER;
exports.RADAR_CONSTS = {
    MAX_CHARACTERS_NO: 500,
    ACTIVE_INPUT_MIN_HEIGHT: 240
};
exports.SUBSCRIPTION_STATUSES = {
    ACTIVE: 'ACTIVE',
    AUTHORIZATION_CANCELED: 'AUTHORIZATION_CANCELED',
    AUTHORIZATION_REQUIRED: 'AUTHORIZATION_REQUIRED',
    CANCELED: 'CANCELED',
    ERROR: 'ERROR',
    EXPIRED: 'EXPIRED',
    ON_HOLD: 'ON_HOLD',
    PURCHASING: 'PURCHASING',
    SUSPENDED: 'SUSPENDED',
    REFUNDED: 'REFUNDED'
};
exports.AD_PROVIDERS = {
    ADMOB: 'admob'
};
var EUrlOpeningMode;
(function (EUrlOpeningMode) {
    EUrlOpeningMode["InAppBrowser"] = "in-app-browser";
    EUrlOpeningMode["ExternalBrowser"] = "external-browser";
    EUrlOpeningMode["WebviewGame"] = "webview-game";
})(EUrlOpeningMode = exports.EUrlOpeningMode || (exports.EUrlOpeningMode = {}));
